var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "madd" },
    [
      _c("div", { staticClass: "madd__header" }, [
        _vm.resource.country
          ? _c("img", {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: _vm.resource.country.name,
                  expression: "resource.country.name",
                },
              ],
              staticClass: "flag madd__flag",
              attrs: { src: _vm.resource.country.flag },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("h2", {
          staticClass: "madd__title",
          domProps: {
            textContent: _vm._s(
              _vm.resource.companyName
                ? _vm.resource.companyName
                : _vm.resource.projectName
            ),
          },
        }),
        _vm._v(" "),
        _vm.resource.urgent
          ? _c("span", { staticClass: "pill pill--urgent madd__pill" }, [
              _vm._v("Urgent"),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("DataList", {
        staticClass: "madd__datalist",
        attrs: {
          columns: 2,
          items: [
            {
              title: "Completed Date",
              value: _vm.resource.completedAt,
              icon: "calendar",
              isSector: false,
            },
            {
              title: "Deal Type",
              value: _vm.resource.dealType,
              icon: "deal",
              isSector: false,
            },
            {
              title: "Counterpart Company",
              value: _vm.resource.counterpartCompany,
              icon: "company",
              isSector: false,
            },
            {
              title: "Transaction Value",
              value: `${_vm.resource.transactionCurrency}${_vm.resource.transactionValue}m`,
              icon: "value",
              isSector: false,
            },
          ],
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "datalist madd__sectors" }, [
        _c("div", { staticClass: "datalist__item dataitem" }, [
          _c("dt", {
            staticClass: "dataitem__title",
            domProps: { textContent: _vm._s("Sector") },
          }),
          _vm._v(" "),
          _c(
            "dd",
            { staticClass: "dataitem__value" },
            _vm._l(_vm.resource.sectors, function (sector) {
              return _c("span", {
                staticClass: "sector",
                domProps: { textContent: _vm._s(sector.name) },
              })
            }),
            0
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.resource && _vm.resource.id
        ? _c(
            "router-link",
            {
              staticClass: "btn btn--outline",
              attrs: {
                to: {
                  name: "view-madd",
                  params: {
                    madd_id: _vm.resource.id,
                  },
                },
              },
            },
            [_vm._v("\n        View MADD\n    ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }